"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseConfigurationTypes = void 0;
var BaseConfigurationTypes;
(function (BaseConfigurationTypes) {
    BaseConfigurationTypes["APPROPRIATE_USE_PROCESS"] = "Appropriate Use Process";
    BaseConfigurationTypes["RESOURCE_USE"] = "Resource Use";
    BaseConfigurationTypes["EFFICIENCY"] = "Efficiency";
    BaseConfigurationTypes["INTERMEDIATE_OUTCOME"] = "Intermediate Outcome";
    BaseConfigurationTypes["OUTCOME"] = "Outcome";
    BaseConfigurationTypes["EXPERIENCE"] = "Experience";
    BaseConfigurationTypes["PATIENT_REPORTED_OUTCOME"] = "Patient Reported Outcome";
    BaseConfigurationTypes["PROCESS"] = "Process";
    BaseConfigurationTypes["STRUCTURE"] = "Structure";
})(BaseConfigurationTypes = exports.BaseConfigurationTypes || (exports.BaseConfigurationTypes = {}));
